import type { ImageId } from '../../assets/marketing/manifest';

/**
 * Focal points (CSS object-position) per image, hand-set after looking at the
 * frame — where the subject sits when the crop is tighter than the source.
 * Anything not listed centres.
 */
export const FOCAL: Partial<Record<ImageId, string>> = {
  'hero-frost-fields': '45% 50%', // the copse sits just left of centre; the portrait film's crop (x = 0.45 × (3840 − 1440)) keeps the same point, so still and film line up
  'hero-pond-dive': '10% 70%', // the diver is bottom-left; a portrait phone crop shows ~a quarter of the width
  'hero-laptop-sofa': '62% 40%',
  'hero-about': '50% 55%',
  'hero-assessments': '55% 50%',
  'strip-01': '50% 40%',
  'strip-03': '55% 50%',
  'pillar-family': '50% 45%',
  'pillar-bloodwork': '50% 40%',
  'portrait-swim': '50% 35%',
  'closing-window-coast': '60% 50%',
};

export const focal = (id: ImageId): string | undefined => FOCAL[id];
